import { FaIcon } from '@/lib/fa'
import { Button } from '@/ui'
import { faAbacus, faFolderArrowDown } from '@fortawesome/pro-light-svg-icons'
import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
}

export const PayrollEmptyScreen = ({ }: Props) => {
    const { t } = useLocalize()
    return (
        <div className='tw-p-10 tw-h-full tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-4'>
            <FaIcon icon={faAbacus} className='tw-w-10 tw-h-10' /> 
            <div className='tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-max-w-[236px] tw-text-center'>
                <h3 className='tw-mb-1 tw-text-lg'>{t('timesheet.calculate-timesheet')}</h3>
                <p className='tw-text-sm tw-mb-0 tw-text-content-base'>{t('timesheet.calculate-view-description')}</p>
            </div>
            <div className='tw-flex tw-justify-center tw-items-center tw-gap-4'>
                <Button faLeadingIcon={faFolderArrowDown} text={t('timesheet.import-from-file')} variant='secondary' />
                <Button faLeadingIcon={faAbacus} text={t('timesheet.calculate-from-data')} variant='primary' />
            </div>
        </div>
    )
}
